import { useState, useRef, useEffect } from "react";

export default function AttemptDropdown({ assessments, selectedAttemptIndex, onSelect }) {
    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);

    useEffect(() => {
        if (!open) return undefined;
        const handleClick = (e) => {
            if (rootRef.current && !rootRef.current.contains(e.target)) setOpen(false);
        };
        const handleKey = (e) => {
            if (e.key === "Escape") setOpen(false);
        };
        document.addEventListener("mousedown", handleClick);
        document.addEventListener("touchstart", handleClick);
        document.addEventListener("keydown", handleKey);
        return () => {
            document.removeEventListener("mousedown", handleClick);
            document.removeEventListener("touchstart", handleClick);
            document.removeEventListener("keydown", handleKey);
        };
    }, [open]);

    const selected = assessments[selectedAttemptIndex];

    return (
        <div ref={rootRef} style={{ position: "relative", display: "inline-block" }}>
            <button
                type="button"
                onClick={() => setOpen((o) => !o)}
                className="border rounded-md px-3 py-2 text-sm"
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    backgroundColor: "#fff",
                    color: "#111827",
                    cursor: "pointer",
                    borderColor: open ? "#2563EB" : undefined,
                    minWidth: 140,
                    justifyContent: "space-between",
                }}
            >
                <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {selected ? selected.title : "Select attempt"}
                </span>
                <svg
                    width="12" height="12" viewBox="0 0 24 24" fill="none"
                    stroke={open ? "#2563EB" : "#6B7280"} strokeWidth="2"
                    style={{ transform: open ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.15s", flexShrink: 0 }}
                >
                    <path d="M6 9l6 6 6-6" />
                </svg>
            </button>
            {open && (
                <div
                    style={{
                        position: "absolute",
                        top: "calc(100% + 6px)",
                        left: 0,
                        backgroundColor: "#fff",
                        border: "1px solid #E5E7EB",
                        borderRadius: 10,
                        boxShadow: "0 8px 24px rgba(15, 23, 42, 0.12)",
                        overflow: "hidden",
                        zIndex: 30,
                        minWidth: 180,
                        maxHeight: 260,
                        overflowY: "auto",
                    }}
                >
                    {assessments.map((attempt, index) => {
                        const isSelected = index === selectedAttemptIndex;
                        return (
                            <button
                                key={attempt.id}
                                type="button"
                                onClick={() => { onSelect(index); setOpen(false); }}
                                style={{
                                    display: "block",
                                    width: "100%",
                                    textAlign: "left",
                                    padding: "10px 14px",
                                    fontSize: 14,
                                    fontWeight: isSelected ? 600 : 400,
                                    color: isSelected ? "#2563EB" : "#374151",
                                    backgroundColor: isSelected ? "#EFF6FF" : "#fff",
                                    border: "none",
                                    cursor: "pointer",
                                }}
                                onMouseEnter={(e) => { if (!isSelected) e.currentTarget.style.backgroundColor = "#F9FAFB"; }}
                                onMouseLeave={(e) => { if (!isSelected) e.currentTarget.style.backgroundColor = "#fff"; }}
                            >
                                {attempt.title}
                            </button>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
